// CompanyApplicationsPage.js
import React, { useState } from "react";
// import CompanyApplicationsTable from './Components/CompanyApplicationsTable';
import SimplePageHeader from "./Components/Navigation/SimplePageHeader";
import InfoBanner from "./Components/Navigation/InfoBanner";
import CompanyApplicationCards from "./Components/Companies/CompanyApplicationsCard";

function CompanyManagement() {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (term) => {
    setSearchTerm(term);
  };

  return (
    <>
      <SimplePageHeader
        iconName="companies"
        pageType="companies"
        placeholderText="Search by Client Code only"
        titleString={"Manage Companies"}
        onSearchChange={handleSearchChange}
        showAddButton={true}
      />
      <InfoBanner
        message={
          "This page can be used to define which applications are deployed for computers associated with specific companies and which settings are applied.\nIf a PC is deployed to a company that has no existing applications defined, a new company will be created and the default applications and settings will be selected.\nNew companies can be also be added before deploying any PCs."
        }
        localStorageKey="company-applications-page1" // Unique key for this page
      />

      <div style={{ padding: "0 20px 20px 20px" }}>
        {/* <CompanyApplicationsTable searchTerm={searchTerm} /> Pass searchTerm to the table */}
        <CompanyApplicationCards searchTerm={searchTerm} />
      </div>
    </>
  );
}

export default CompanyManagement;
